import superagentRequest from 'superagent'
import jsonp from 'superagent-jsonp'

import { request } from '../sharedLegacy/utils'

export const getConnectionInfo = ({
  liveId,
  presenterToken,
  role,
  isBustingGhosts = false,
  isPrejoining = false,
  url = '/api/live/webinar/connect',
}) => {
  const data = {
    live_id: liveId,
    bust_ghosts_p: isBustingGhosts ? 1 : 0,
    prejoin_p: isPrejoining ? 1 : 0,
  }

  if (presenterToken) {
    data.presenter_token = presenterToken
  }

  if (role) {
    data.role = role
  }

  return request({
    url,
    method: 'POST',
    data,
  })
}

export const getWebinarInfo = async (liveId, presenterToken) => {
  const url = '/api/live/webinar/info'

  const { webinar } = await request({
    url,
    method: 'GET',
    data: {
      live_id: liveId,
      presenter_token: presenterToken,
    },
  })

  return webinar
}

export const getSpeakers = (liveId, token) => {
  const url = '/api/live/speaker/list'

  return request({
    url,
    method: 'POST',
    data: {
      live_id: liveId,
      token,
      exclude_hidden_p: 1,
    },
  })
}

export const getLiveData = async (liveId, token, options = {}) => {
  const url = '/api/live/list'
  const { includePublishDetails, includeFmleURL } = options
  const data = {
    live_id: liveId,
    include_stats_p: 1,
  }

  if (token) {
    data.token = token
  } else {
    data.stream_preview_p = 1
  }

  if (includePublishDetails) {
    data.include_publish_details_p = 1
    data.stream_preview_p = 1
  }

  if (includeFmleURL) {
    data.include_fmle_url_p = 1
    data.stream_preview_p = 1
  }

  const { firstlive } = await request({
    url,
    data,
  })

  return firstlive
}

export const toggleLive = (liveId, shouldBroadcast) => {
  const url = '/api/live/update'

  return request({
    url,
    method: 'POST',
    data: {
      live_id: liveId,
      broadcasting_p: shouldBroadcast ? 1 : 0,
      recording_p: shouldBroadcast ? 1 : 0,
      live_status: shouldBroadcast ? 'live' : 'previous',
    },
  })
}

export const fetchSchedules = (liveId, token) => {
  const url = '/api/live/schedule/list'

  return request({
    url,
    method: 'GET',
    data: {
      live_id: liveId,
      token,
    },
  })
}

export const reportLiveError = (
  liveId,
  presenterToken,
  reportType,
  errorMessage,
  metrics
) => {
  const url = '/api/live/slack-report'
  const options = {
    url,
    method: 'POST',
    data: {
      live_id: liveId,
      report_type: reportType,
      error_message: errorMessage,
      metrics: JSON.stringify(metrics),
    },
  }

  if (presenterToken) {
    options.data.presenter_token = presenterToken
  }

  return request(options)
}

export const getSecondCamCode = (liveId, presenterToken) => {
  const url = '/api/live/webinar/connect'

  return request({
    url,
    method: 'GET',
    data: {
      live_id: liveId,
      presenter_token: presenterToken,
      include_camera_authentication_p: 1,
    },
  })
}

// Temp solution before removing the iframe in the webinar room
export const fetchLiveFunnelData = async (liveId, domain) => {
  const url = '/api/audience/funnel'

  return await superagentRequest
    .get(`${domain}${url}`)
    .query({
      objects: liveId,
      live_type: 'live',
      format: 'json',
    })
    .use(
      jsonp({
        timeout: 10000,
        callbackName: 'funnelJsonpFunc',
      })
    )
}

export const fetchLiveMetrics = async (liveId, domain) => {
  const url = '/api/live/metrics'

  return await superagentRequest
    .get(`${domain}${url}`)
    .query({
      live_id: liveId,
      format: 'json',
    })
    .use(
      jsonp({
        timeout: 10000,
        callbackName: 'metricsJsonpFunc',
      })
    )
}

export const switchToGearMode = (liveId) => {
  const url = '/api/live/update'

  return request({
    url,
    method: 'POST',
    data: {
      live_id: liveId,
      streaming_method: 'hardware',
    },
  })
}
